<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/perdoruesit/depoistet">Depoistët</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.first_name }} {{form.last_name}}
    </h1>
    <trashed-message v-if="warehouseman.deleted_at" class="mb-6" @restore="restore"> Ky depoist është fshirë nga sistemi. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Emri" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Mbiemri" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Numri i telefonit" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.second_phone" :error="form.errors.second_phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Numri i telefonit(sekondar)" />

          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2" label="Adresa" />


          <file-output v-if="form.id_document_path_front"  v-model="form.id_document_path_front" :error="form.errors.id_document_path_front" class="pb-8 pr-6 w-full lg:w-1/2"  label="Letërnjoftimi (Para)" />
          <file-input v-else  v-model="form.id_document_front" :error="form.errors.id_document_front" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Letërnjoftimi (Para)" />


          <file-output v-if="form.id_document_path_back" v-model="form.id_document_path_back" :error="form.errors.id_document_path_back" class="pb-8 pr-6 w-full lg:w-1/2"  label="Letërnjoftimi (Prapa)" />
          <file-input v-else v-model="form.id_document_back" :error="form.errors.id_document_back" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Letërnjoftimi (Prapa)" />


          <file-output v-if="form.driving_license_path_front" v-model="form.driving_license_path_front" :error="form.errors.driving_license_path_front" class="pb-8 pr-6 w-full lg:w-1/2"  label="Patent shoferi (Para)" />
          <file-input v-else v-model="form.driving_license_front" :error="form.errors.driving_license_front" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Patent shoferi (Para)" />


          <file-output v-if="form.driving_license_path_back" v-model="form.driving_license_path_back" :error="form.errors.driving_license_path_back" class="pb-8 pr-6 w-full lg:w-1/2" label="Patent shoferi (Prapa)" />
          <file-input v-else v-model="form.driving_license_back" :error="form.errors.driving_license_back" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Patent shoferi (Prapa)" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="user.role === 'superadmin' && !warehouseman.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Fshij</button>
          <button v-if="user.role === 'superadmin' && warehouseman.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="forceDelete">Fshij përgjithmonë</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Edito</loading-button>
        </div>
      </form>
    </div>

    <div v-if="user.role === 'superadmin'" class="max-w-3xl mt-10 bg-white rounded-md shadow overflow-hidden">
      <form id="updatePassword" @submit.prevent="updatePassword">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input type="password" v-model="updatePasswordForm.new_password" :error="updatePasswordForm.errors.new_password" class="pb-8 pr-6 w-full lg:w-full" label="Fjalëkalimi i ri"  />
          <text-input type="password" v-model="updatePasswordForm.new_confirm_password" :error="updatePasswordForm.errors.new_confirm_password" class="pb-8 pr-6 w-full lg:w-full" label="Konfirmo fjalëkalimin e ri"/>


        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="updatePasswordForm.processing" class="btn-indigo ml-auto" type="button" @click="updatePassword">Ndrysho fjalëkalimin</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import {computed} from 'vue'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileInput from '@/Shared/FileInput'
import FileOutput from '@/Shared/FileOutput'


export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    FileInput,
    FileOutput
  },
  layout: Layout,
  props: {
    warehouseman: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        id: this.warehouseman.id,
        first_name: this.warehouseman.first_name,
        last_name: this.warehouseman.last_name,
        email: this.warehouseman.email,
        phone: this.warehouseman.phone,
        second_phone: this.warehouseman.second_phone,
        address: this.warehouseman.address,
        id_document_path_front: this.warehouseman.id_document_path_front,
        id_document_path_back: this.warehouseman.id_document_path_back,
        driving_license_path_front: this.warehouseman.driving_license_path_front,
        driving_license_path_back: this.warehouseman.driving_license_path_back,
        id_document_front: null,
        id_document_back:null,
        driving_license_front: null,
        driving_license_back: null
      }),
      updatePasswordForm: this.$inertia.form({
        new_password: null,
        new_confirm_password: null
      })
    }
  },
  methods: {
    update() {
      this.form.post(`/admin/perdoruesit/depoistet/${this.warehouseman.id}`)
    },
    destroy() {
      if (confirm('A jeni të sigurt?')) {
        this.$inertia.delete(`/admin/perdoruesit/depoistet/${this.warehouseman.id}`)
      }
    },
    restore() {
      if (confirm('A jeni të sigurt?')) {
        this.$inertia.put(`/admin/perdoruesit/depoistet/${this.warehouseman.id}/restore`)
      }
    },
    forceDelete() {
      if (confirm('Ky veprim është i pakthyeshëm, shoferi nuk mund të kthehet më pas këtij veprimi. A jeni të sigurt se me të vërtetë dëshironi ta fshini këtë depoist?')) {
        this.$inertia.put(`/admin/perdoruesit/depoistet/${this.warehouseman.id}/forceDestroy`)
      }
    },
    updatePassword(){
      this.updatePasswordForm.put(`/admin/perdoruesit/password/${this.warehouseman.id}`)
    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
}
</script>
